import { payload } from "../../../../../node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_GA_ID = "GTM-KLCMV93R";
export const PUBLIC_FB_ID = "612139816001715";
export const PUBLIC_STORYBLOK_ACCESS_TOKEN = "eCSHGB4XHtbxxFVqg2QiSAtt";
